import React from 'react';
import { Select } from 'antd';
import type { DynamicComponentProps } from '@/types/commontypes';
import styles from '../../../styles/global.module.css';

interface SelectInputProps extends DynamicComponentProps<string> {
  options?: string[];
}

/**
 * SelectInput - Dropdown select for shape properties
 */
const SelectInput: React.FC<SelectInputProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  options = [],
  isFromMiniToolbar,
}) => {
  const handleChange = (val: string) => {
    onChange(val);
  };

  const selectOptions = options.map(opt => ({
    value: opt.toLowerCase(),
    label: opt,
  }));

  const selectElement = (
    <Select
      value={value?.toLowerCase()}
      onChange={handleChange}
      disabled={disabled}
      size="small"
      options={selectOptions}
      style={{ minWidth: isFromMiniToolbar ? 80 : 100 }}
    />
  );

  if (isFromMiniToolbar) {
    return <div className="flex items-center gap-2">{selectElement}</div>;
  }

  return (
    <div className={styles.property_row}>
      {label && <label className={styles.property_label}>{label}</label>}
      <div className={styles.property_value}>{selectElement}</div>
    </div>
  );
};

export default SelectInput;
